import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
var DefaultLoading = function DefaultLoading() {
  return /*#__PURE__*/React.createElement("div", null, "Loading...");
};
export var HubspotForm = function HubspotForm(props) {
  var portalId = props.portalId,
    formId = props.formId,
    _props$scriptSrc = props.scriptSrc,
    scriptSrc = _props$scriptSrc === void 0 ? "//js.hsforms.net/forms/shell.js" : _props$scriptSrc,
    _props$onLoading = props.onLoading,
    onLoading = _props$onLoading === void 0 ? /*#__PURE__*/React.createElement(DefaultLoading, null) : _props$onLoading;
  var _useState = useState(true),
    loading = _useState[0],
    setLoading = _useState[1];
  useEffect(function () {
    var script = document.createElement("script");
    script.src = scriptSrc;
    document.body.appendChild(script);
    var addListener = function addListener() {
      var _window$hbspt;
      window.hbspt.forms.create({
        portalId: portalId,
        formId: formId,
        target: "#hubspotform"
      });
      if ((_window$hbspt = window.hbspt) === null || _window$hbspt === void 0 ? void 0 : _window$hbspt.forms) setLoading(false);
    };
    script.addEventListener("load", addListener);
    return function () {
      return script.removeEventListener("load", addListener);
    };
  }, [portalId, formId, scriptSrc]);
  return /*#__PURE__*/React.createElement("div", {
    id: "hubspotform"
  }, loading ? onLoading : null);
};
HubspotForm.propTypes = process.env.NODE_ENV !== "production" ? {
  portalId: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  scriptSrc: PropTypes.string,
  onLoading: PropTypes.object
} : {};
HubspotForm.defaultProps = {
  scriptSrc: "//js.hsforms.net/forms/shell.js"
};
export default HubspotForm;